import React, { FunctionComponent, useEffect, useRef } from 'react'
import Scrollchor, { IScrollchorElement } from 'react-scrollchor'

export const ScrollToTopOnMount: FunctionComponent<{}> = () => {
  const scrollchorElement = useRef<IScrollchorElement>(null)
  useEffect(() => {
    scrollchorElement.current && scrollchorElement.current.simulateClick()
  })

  return <Scrollchor ref={scrollchorElement} to='progressbar' disableHistory />
}
